import API from "../../api/usrmgmtservice";
import router from "../../router/index";
import appConstants from "../../appConstants.js";

const state = {
  masterChartInfo: [],
  approvedUsers: [],
  pendingUsers: [],
  rejectedUsers: [],
  countryCodes: [],
  editedUserDetials: [],
  notifications: [],
  isLoading: false,
  isUserCreated: false,
};
const getters = {
  masterChartInfo: (state) => state.masterChartInfo,
  approvedUsers: (state) => state.approvedUsers,
  pendingUsers: (state) => state.pendingUsers,
  rejectedUsers: (state) => state.rejectedUsers,
  countryCodes: (state) => state.countryCodes,
  editedUserDetials: (state) => state.editedUserDetials,
  notifications: (state) => state.notifications,
  isLoading: (state) => state.isLoading,
  isUserCreated: (state) => state.isUserCreated,
};
const actions = {
  async countryCode({ commit, dispatch }) {
    dispatch("showLoader");
    try {
      const { data } = await API.countryCode();
      let resdata = data.data;
      commit(
        "SET_COUNTRY_CODES",
        resdata.map(({ name, value }) => {
          return { text: name, value: value };
        })
      );
    } catch (error) {
      console.error(error);
    }
    dispatch("hideLoader");
  },
  async getAllUserList({ commit }) {
    try {
      const { data } = await API.userData();
      let users = data.message;
      if (users.approved) {
        commit("SET_APPROVED_USER_LIST", users.approved);
      } else {
        commit("SET_APPROVED_USER_LIST", []);
      }
      if (users.pending) {
        commit("SET_PENDING_USER_LIST", users.pending);
      } else {
        commit("SET_PENDING_USER_LIST", []);
      }
      if (users.approve_access) {
        commit("SET_REJECTED_USER_LIST", users.approve_access);
      } else {
        commit("SET_REJECTED_USER_LIST", []);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async getMasterChartsInfo({ commit }) {
    try {
      const { data } = await API.masterData();
      // console.log("dataaaaaaaa", data);
      commit("SET_MASTER_CHART_INFO", data.message.customizeaccessdata);
    } catch (error) {
      console.error(error);
    }
  },
  async modifyUserAccessData({ commit }, data) {
    try {
      // console.log("data-=-=-", data);
      let response = await API.modifyUserAccessData(data);
      let notification = {
        message: `${response.data.message}`,
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      return response;
    } catch (error) {
      console.error(error);
      // message: `${data.objectname}, ${error.response.data.message}`,
      let notification = {
        message: `${error.response.data.message}`,
        type: "DANGER",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      return error.response;
    }
  },
  async getEditedUserAccessDetails({ commit }, userId) {
    commit("SET_MASTER_CHART_INFO", []);
    try {
      const { data } = await API.editedUserAccessData(userId);
      // console.log("0000000000000000", data);
      let userData = data.message.data;
      commit("SET_EDIT_USER_ACCESS_DETAILS", userData);
      commit("SET_MASTER_CHART_INFO", userData);
      if (!window.location.pathname.includes("customizeAccess")) {
        router.push({ path: `/customizeAccess/${userId}/` });
      }
    } catch (error) {
      console.error("Login ERROR.....", error);
      commit("SET_ERROR", error);
    }
  },
  async deleteUser({ commit }, userId) {
    try {
      const { data } = await API.deleteUserAPI(userId);
      // let userData = data.message.data;
      let notification = {
        message: `${data.message}`,
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
    } catch (error) {
      console.error("Login ERROR.....", error);
      commit("SET_ERROR", error);
    }
  },
  async rejectedUser({ commit }, userId) {
    try {
      const { data } = await API.rejectedUserAPI(userId);
      // let userData = data.message.data;
      let notification = {
        message: `${data.message}`,
        type: "SUCCESS",
      };
      // console.log("rejecttttttt", data);
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
    } catch (error) {
      console.error("Login ERROR.....", error);
      commit("SET_ERROR", error);
    }
  },
  async approvedUserById({ commit }, userId) {
    try {
      // console.log("userId", userId);
      const { data } = await API.approvedUserById(userId.id);
      let notification = { message: `${data.message}`, type: "SUCCESS" };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
    } catch (error) {
      console.error("Login ERROR.....", error);
      commit("SET_ERROR", error);
    }
  },
  async addNotification({ commit }, notification) {
    commit("PUSH_NOTIFICATION", notification);
    setTimeout(() => {
      commit("PUSH_NOTIFICATION", {});
    }, 7000);
  },
  async removeNotification({ commit }, notification) {
    commit("REMOVE_NOTIFICATION", notification);
  },
  async showLoader({ commit }) {
    commit("SET_LOADER_ON");
  },
  async hideLoader({ commit }) {
    commit("SET_LOADER_OFF");
  },
  async registeradmin({ commit, dispatch }, data) {
    dispatch("showLoader");
    try {
      let response = await API.registeradmin(data);
      if (response.status == 201) {
        dispatch("userCreated");
        let notification = {
          message: `${response.data.message}`,
          type: "SUCCESS",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        dispatch("getAllUserList");
        dispatch("hideLoader");
      }
      return response;
    } catch (error) {
      // console.error("registration error", error);
      commit("SET_ERROR", error);
      commit("SET_ERROR_NOTIFICATIONS", error);
      let data = error.response.data;
      let notificationMessage;
      for (let key in data) {
        if (key != "status") {
          if (typeof data[key] != "string") {
            notificationMessage = data[key][0];
          } else {
            notificationMessage = data[key];
          }
          let notification = {
            message: notificationMessage,
            type: "DANGER",
          };
          commit("PUSH_NOTIFICATION", notification);
        }
      }
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      dispatch("hideLoader");
      return error.response;
    }
  },
  async userCreated({ commit }) {
    commit("SET_USER_CREATED");
  },
  async setUserCreatedToFalse({ commit }) {
    commit("SET_USER_CREATED_FALSE");
  },
};
const mutations = {
  SET_MASTER_CHART_INFO: (state, chartsinfo) => {
    state.masterChartInfo = chartsinfo;
  },
  SET_PENDING_USER_LIST: (state, pendingusr) => {
    state.pendingUsers = pendingusr;
  },
  SET_APPROVED_USER_LIST: (state, approvedusr) => {
    state.approvedUsers = approvedusr;
  },
  SET_REJECTED_USER_LIST: (state, rejectedusr) => {
    state.rejectedUsers = rejectedusr;
  },
  SET_COUNTRY_CODES: (state, countries) => {
    // console.log("countries", countries);
    state.countryCodes = countries;
  },
  SET_EDIT_USER_ACCESS_DETAILS: (state, usrdetails) => {
    state.editedUserDetials = usrdetails;
  },
  PUSH_NOTIFICATION: (state, notification) => {
    state.notifications = [];
    state.notifications.push({
      ...notification,
      id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
    });
  },
  REMOVE_NOTIFICATION: (state, notificationToRemove) => {
    state.notifications = state.notifications.filter((notification) => {
      return notification.id != notificationToRemove.id;
    });
  },
  SET_ERROR_NOTIFICATIONS: (state, errors) => {
    let errormsg = "";
    if (errors.response.status == 400) {
      const { data } = errors.response;
      let msgs = [];
      Object.keys(data).forEach((key) =>
        msgs.push(`${key}:${data[key].join()}`)
      );
      errormsg = msgs.join();
    }
    if (errors.response.status == 500) {
      const { data } = errors.response;
      errormsg = data.message;
    }
    // console.log("errormsg", errormsg);
    let notification = {
      message: errormsg,
      type: "ERROR",
    };
    state.notifications.push({
      ...notification,
      id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
    });
  },
  SET_LOADER_ON: (state) => {
    state.isLoading = true;
  },
  SET_LOADER_OFF: (state) => {
    state.isLoading = false;
  },
  SET_USER_CREATED: (state) => {
    state.isUserCreated = true;
  },
  SET_USER_CREATED_FALSE: (state) => {
    state.isUserCreated = false;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
